import React from 'react';
import CameraFunctions from '../AttendanceCamera/CameraFunctions';

class CameraMultiComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isImageVisible: false,
            capturedPhoto: null,
        };
        this.imageId = `captured-photo-${this.props.imgType}`;
    }

    componentDidMount() {
        if (window.cordova) {
            if (document.readyState === 'complete' || document.readyState === 'interactive') {
                this.capturePhoto();
            } else {
                document.addEventListener('deviceready', this.capturePhoto, false);
            }
        }
    }

    componentWillUnmount() {
        document.removeEventListener('deviceready', this.capturePhoto);
    }

    capturePhoto = () => {
        CameraFunctions.capturePhoto(
            this.handlePhotoSuccess,
            this.handlePhotoError,
            {
                quality: 85,
                targetWidth: 450,
                targetHeight: 800,
            }
        );
    };

    handlePhotoSuccess = (imageURI) => {
        const image = document.getElementById(this.imageId);
        if (image) {
            image.src = imageURI;
        }
        this.setState({
            capturedPhoto: imageURI,
            isImageVisible: true,
        });
        if (typeof this.props.onImageCapture === 'function') {
            this.props.onImageCapture(imageURI);
        }
    };

    handlePhotoError = (errorMessage) => {
        alert(errorMessage);
    };

    render() {
        return (
            <div style={{ textAlign: 'center', margin: '15px 0' }}>
                <button 
                    type="button" 
                    onClick={this.capturePhoto} 
                    style={{ 
                        marginBottom: '15px',
                        width: 'auto',
                        minWidth: '220px',
                        padding: '12px 24px',
                        backgroundImage: this.state.isImageVisible ? 'linear-gradient(135deg, #FF9800 0%, #F57C00 100%)' : 'linear-gradient(135deg, #1a73e9 0%, #1557b0 100%)',
                        color: 'white',
                        border: 'none',
                        borderRadius: '25px',
                        fontSize: '15px',
                        fontWeight: '600',
                        letterSpacing: '0.5px',
                        cursor: 'pointer',
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
                        transition: 'transform 0.2s, box-shadow 0.2s'
                    }}
                >
                    <i className={this.state.isImageVisible ? "fas fa-redo-alt" : "fas fa-camera"} style={{ marginRight: '8px' }}></i>
                    {this.state.isImageVisible ? 'Retake Photo' : 'Capture Photo'}
                </button>
                {this.state.isImageVisible && (
                    <img
                        id={this.imageId}
                        style={{ display: 'block', margin: '0 auto', width: '50%', borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.15)' }}
                        src={this.state.capturedPhoto}
                        alt={`Captured ${this.props.imgType} Image`}
                    />
                )}
            </div>
        );
    }
}

export default CameraMultiComponent;
